module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/blog-banner-2-400.a6d4a5ec0e98a981.jpg"+" 400w"+","+"https://static.sniffspot.com/packs/img/blog-banner-2-500.637342586ad62713.jpg"+" 500w",
        images: [{path: "https://static.sniffspot.com/packs/img/blog-banner-2-400.a6d4a5ec0e98a981.jpg",width: 400,height: 534},{path: "https://static.sniffspot.com/packs/img/blog-banner-2-500.637342586ad62713.jpg",width: 500,height: 667}],
        src: "https://static.sniffspot.com/packs/img/blog-banner-2-500.637342586ad62713.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/blog-banner-2-500.637342586ad62713.jpg"},
        
        width: 500,
        height: 667
      }